// 운영 화면의 상태 값 → sds-badge 톤. 규격: docs/superpowers/specs/2026-09-14-ops-auth-toss.md "상태 배지 색".
//
// 빨강(danger)은 정말 문제인 상태(정지·실패)에만 쓴다. 운영 화면에 빨강이 흔하면
// 대시보드의 위험 신호가 무뎌진다. 거절·종결처럼 일이 끝난 상태는 회색이다.
// 모르는 값은 회색이다 — 모르는 것을 초록이나 빨강으로 칠하면 없는 판정을 만든다.
const TONES = {
    normal: ['활성', '허용', '수락됨', '결제', '사용', '정상', '발송', '완료'],
    caution: ['요청중', '요청 접수', '환불요청', '탈퇴 대기', '진행중', '미완료'],
    danger: ['정지', '실패'],
    info: ['관리자 취소', '사용자 취소'],
    none: ['비활성', '거부', '거절됨', '환불', '미결제', '미사용', '관리자 종결', '자동 종결', '탈퇴', '건너뜀', '미발송', '상태없음']
};

const LOOKUP = Object.entries(TONES).reduce((acc, [tone, labels]) => {
    labels.forEach((label) => { acc[label] = tone; });
    return acc;
}, {});

export default function opsStatusTone(label) {
    if (typeof label !== 'string') return 'none';
    return LOOKUP[label.trim()] || 'none';
}
